import React from "react";
import ExclamationIcon from "../../../../../icons/ExclamationIcon";
import CheckIcon from "../../../../../icons/CheckIcon";
import WifiXLightIcon from "../../../../../icons/WifiXLightIcon";
import RefreshIcon from "../../../../../icons/RefreshIcon";

interface BidNotificationPanelProps {
  notificationType?: "bidFailure" | "bidSuccess" | "unstableNet" | "noInternet";
  reason?: string;
}

export default function BidNotificationPanel({
  notificationType,
  reason,
}: BidNotificationPanelProps) {
  const notificationDefaults = {
    bidFailure: {
      heading: "Bid failed",
      body: reason || "Someone placed a higher bid than you",
      bgClass: "bg-[#FFF3F3] border-[#B60100]",
      textColor: "text-[#B60100]",
      Icon: ExclamationIcon,
    },
    bidSuccess: {
      heading: "Bid successful",
      body: "Your bid has been placed successfully!",
      bgClass: "bg-[#FCFFFB] border-[#4DBB3E]",
      textColor: "text-[#4DBB3E]",
      Icon: CheckIcon,
    },
    unstableNet: {
      heading: "Unstable Network",
      body: "Please check your connection and try again.",
      bgClass: "bg-[#FCFFFB] border-[#E0C707]",
      textColor: "text-[#E0C707]",
      Icon: WifiXLightIcon,
    },
    noInternet: {
      heading: "No Internet Connection",
      body: "Please check your connection and try again.",
      bgClass: "bg-[#FCFFFB] border-[#E0C707]",
      textColor: "text-[#E0C707]",
      Icon: WifiXLightIcon,
    },
  };

  const {
    heading = null,
    body = "Page will refresh in 5 seconds",
    bgClass = "bg-[#FCFFFB] border-[#FF752C]",
    textColor = "",
    Icon = RefreshIcon,
  } = notificationType ? notificationDefaults[notificationType] : {};
  return (
    <div className={`border-[1px] ${bgClass} px-1 py-3 text-sm font-sans`}>
      <div className="flex gap-2">
        {Icon && <Icon width={18} height={18} />}
        <div>
          {heading && (
            <div
              className={`text-sm font-sans capitalize mb-[2px] ${textColor}`}
            >
              {heading}
            </div>
          )}
          <div className=" text-brand-textBlack text-xs md:text-sm font-sans pr-2 md:pr-6">
            {body}
          </div>
        </div>
      </div>
    </div>
  );
}
